import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
// Fix Leaflet's default marker icon paths (otherwise icons 404 in bundlers)
const markerIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
// HQ: 76 W Candler St, Suite 6, Winder, GA 30680
const HQ_POSITION: [number, number] = [34.0870795, -83.589403];
export function ServiceMap() {
  return <MapContainer center={HQ_POSITION} zoom={10} scrollWheelZoom={false} style={{
    height: '100%',
    width: '100%'
  }} className="z-0" data-id="element-176">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" data-id="element-177" />
      <Marker position={HQ_POSITION} icon={markerIcon} data-id="element-178">
        <Popup data-id="element-179">
          <strong data-id="element-180">Drop Zone Cleanup Co.</strong>
          <br data-id="element-181" />
          76 W Candler St, Suite 6
          <br data-id="element-182" />
          Winder, GA 30680
        </Popup>
      </Marker>
    </MapContainer>;
}